import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/chat_panel.css */
  .message {
    display: flex;
    justify-content: flex-start;
    background: hsla(0, 0%, 100%, 0.04);
    padding: 10px;
    height: fit-content;
    border-radius: 6px;
    margin: 0 15px 5px 0px;
    position: relative;
  }
  .message:hover {
    background: hsla(0, 0%, 100%, 0.08);
  }
  .message.achivement_announcement_private {
    background: hsla(126, 100%, 38%, 0.1);
  }
  .message.achivement_announcement_private .avatar_image {
    background: url(${icons.ach_check_checked_3}) center center / 20px auto no-repeat;
    width: 20px;
    height: 21px;
  }
  .message .message_content {
    display: inline;
    text-align: left;
    line-height: 140%;
    font-size: 0.75rem;
    margin: 0 0 0 10px;
  }
  .message.achivement_announcement_private .message_content {
    display: flex;
    flex-direction: column;
  }
  .message .message_content .user_name {
    font-weight: 600;
    margin: 0 20px 0 0;
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    position: relative;
    padding: 0;
  }
  .message.achivement_announcement_private .message_content .user_name {
    border-bottom: 0;
    color: #00c314;
    padding-bottom: 3px;
    font-weight: 800;
    display: inline-flex;
    align-items: center;
  }
  .message .message_content .message_copy {
    font-weight: 400;
  }
  .message.achivement_announcement_private .message_content .message_copy b {
    font-weight: 600;
  }
  .message.achivement_announcement_private .message_content .message_copy a {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.4);
  }
  .message.achivement_announcement_private .message_content .message_copy a:hover {
    border-bottom: 1px dotted hsla(0, 0%, 100%, 0.9);
  }
  .message.achivement_announcement_private .message_content .message_copy {
    line-height: 130%;
  }
  .message.achivement_announcement_private .message_content .message_copy ul {
    padding: 5px 0;
  }
  .message.achivement_announcement_private .message_content .message_copy ul li {
    line-height: 130%;
    padding: 2px 0;
  }
`

const developerCSS = css``

export const MultipleAchievementCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
